export default "__VITE_ASSET__BYGHq6Zg__"